import { AuthProvider, TitleProvider } from "./auth/context";
import { useRoutes } from "react-router-dom";
import { routes } from "./routes";
import { useEffect, useState } from "react";
import { Backdrop, CircularProgress, Container } from "@mui/material";

class Loading {
    constructor() {
        this.loadingTag = 0;
        this.subscriptions = [];
    }
    add () {
        this.loadingTag++;
        this.subscriptions.forEach(f => f(this.loadingTag));
    }
    sub () {
        this.loadingTag--;
        this.subscriptions.forEach(f => f(this.loadingTag));
    }
    get () {
        return this.loadingTag;
    }
    subscribe (f) {
        this.subscriptions.push(f);
    }
}

let loadingPublisher = new Loading();
window.loadingPublisher = loadingPublisher;

function App () {
    const content = useRoutes(routes);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        window.loadingPublisher.subscribe(loadingTag => {
            setLoading(loadingTag > 0);
        });
    }, [])

    return (
        <>
            <AuthProvider>
                <Container maxWidth="sm">
                    {content}
                </Container>
            </AuthProvider>
            {
                isLoading &&
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={true}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            }
        </>
    )
}


export default App;